import { Card, CardContent } from '@mui/material';
import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { RenderInputByTypeMobile } from "../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { AptoInput } from "../../RIValidation/components/AptoInput";
import { ContratosPaciente } from '../../RIValidation/components/ContratosPaciente';
import { Indicaciones } from '../../RIValidation/components/Indicaciones';
import { InfoControl } from '../../RIValidation/components/InfoControl';
import { GenerarRIInput } from './GenerarRIInput';
import { useGetActions } from '../hooks/useGetActions';
import { AdicionalInput } from '../../RIValidationCambioIndicacion/components/AdicionalInput';
import { ProfesionalesInput } from '../../RIValidationCambioIndicacion/components/ProfesionalesInput';

export const RIValidationIndicacionContent = ({ setChildrenAction, esCambioIndicacion }) => {
    const location = useLocation();
    const stateData = location.state;
    const { notificationData, idTipoModulo, tipoNotificacion, hasIndication, hasProfessionalScreen,
        hasEsquemaBAP, moduloCP, moduloCD, moduloHE, moduloSSAE, moduloSI, canGenerateRI, idDelegacion } = stateData;
    const [notification, setNotification] = useState(notificationData || {});
    const [contratosIds, setContratosIds] = useState([]);
    const [requiereIndicacion, setRequiereIndicacion] = useState(true);
    const [countIndicaciones, setCountIndicaciones] = useState(0);

    const handleChange = (name, value) => {
        setNotification(prevDatos => ({
            ...prevDatos,
            [name]: value
        }));
    }

    const {
        handleClickValidar,
        handleClickNotificar,
        loading: buttonActionLoading
    } = useGetActions({
        notification,
        moduloHE,
        moduloSI,
        moduloCP,
        moduloSSAE,
        moduloCD,
        hasEsquemaBAP,
        tipoNotificacion: esCambioIndicacion ? "CAMBIO_INDICACION" : "INGRESO_INDICACION",
    });

    useEffect(() => {
        if (!notification) return setChildrenAction(null);

        setChildrenAction(() => (
            (notification.estadoValidacion !== 'Validado' && <div className='top-buttons'>
                {canGenerateRI && notification.estadoCoordinador !== 'Correccion' && <div className="margin-right">
                    <GenerarRIInput
                        loadingOthersButtons={buttonActionLoading}
                        handleClickAceptar={() => handleClickNotificar()}
                    />
                </div>}
                <div className='margin-right'>
                    <AptoInput
                        idEvaluacion={notification?.idEvaluacion}
                        loadingValidar={buttonActionLoading}
                        handleClickAceptar={(rechazo) => handleClickValidar(rechazo, requiereIndicacion, countIndicaciones)}
                        isReject={true}
                    />
                </div>
                <div className='margin-right'>
                    <AptoInput
                        idEvaluacion={notification?.idEvaluacion}
                        loadingValidar={buttonActionLoading}
                        handleClickAceptar={(rechazo) => handleClickValidar(rechazo, requiereIndicacion, countIndicaciones)}
                    />
                </div>
            </div>)
        ))
    }, [notification, buttonActionLoading, countIndicaciones, requiereIndicacion, canGenerateRI]);

    return <>

        <InfoControl
            notification={notification}
            tipoNotificacion={tipoNotificacion}
        />
        <ContratosPaciente
            idPaciente={notification?.hC}
            setContratosIds={setContratosIds}
        />
        {
            (hasIndication && !moduloHE) && <>
                {
                    moduloSI && <Card sx={{ width: '100%', marginTop: '30px' }} elevation={0}>
                        <CardContent>
                            <div className='step-form-section-container'>
                                <RenderInputByTypeMobile
                                    handleChange={(_, value) => setRequiereIndicacion(value)}
                                    input={{
                                        name: 'requiereIndicacion',
                                        displayName: 'Requiere Indicacion',
                                        type: 'boolean',
                                        required: true,
                                        disabled: false
                                    }}
                                    value={requiereIndicacion}
                                />
                            </div>
                        </CardContent>
                    </Card>
                }
                {
                    (!moduloSI || (moduloSI && requiereIndicacion)) && <Indicaciones
                        idEvaluacion={notification?.idEvaluacion}
                        idTipoModulo={notification?.idTipoModulo}
                        setCountIndicaciones={setCountIndicaciones}
                        readOnly={notification.estadoValidacion === 'Validado'}
                        hasEsquemaBAP={hasEsquemaBAP}
                    />
                }
            </>
        }
        {
            hasProfessionalScreen && <>
                <ProfesionalesInput
                    idEvaluacion={notification?.idEvaluacion}
                    readOnly={notification.estadoValidacion === 'Validado'}
                    moduloCP={moduloCP}
                />
                <AdicionalInput
                    idEvaluacion={notification?.idEvaluacion}
                    readOnly={notification.estadoValidacion === 'Validado'}
                />
            </>
        }
    </>
}